export default {
    LINES: "Lines",
    LINES_SEARCH: "Lines",
    LINES_EDIT: "Edit Lines",
    LINES_CREATE: "Create Lines",
    DEBATE_NOTES: "Debates",
    DEBATE_NOTES_SEARCH: "Debates",
    DEBATE_NOTES_EDIT: "Edit Debates",
    DEBATE_NOTES_CREATE: "Create Debates",
    MP_PROFILES: "Profiles",
    MP_PROFILES_SEARCH: "Profiles",
    MP_PROFILES_EDIT: "Edit Profiles",
    MP_PROFILES_CREATE: "Create Profiles",
    BRIEFS: "Briefs",
    BRIEFS_SEARCH: "Briefs",
    BRIEFS_EDIT: "Edit Briefs",
    BRIEFS_CREATE: "Create Briefs",
    ACHIEVEMENTS: "Achievements",
    ACHIEVEMENTS_SEARCH: "Achievements",
    ACHIEVEMENTS_EDIT: "Edit Achievements",
    ACHIEVEMENTS_CREATE: "Create Achievements",
    RESOURCES: "Resources",
    RESOURCES_SEARCH: "Resources",
    RESOURCES_EDIT: "Edit Resources",
    RESOURCES_CREATE: "Create Resources",
    FAQS: "FAQ",
    FAQS_SEARCH: "FAQ",
    FAQS_EDIT: "FAQ",
    FAQS_CREATE: "FAQ",
    PEOPLE: "People",
    USERS: "User Search",
    USERS_SEARCH: "User Search",
    USERS_CREATE: "Create External User",
    USERS_EDIT: "User Edit",
    ADVANCED_SEARCH: "Search",
    DATA_ENTRY: "Data Entry",
    UNPUBLISHED_CONTENT: "Un-published Content",
    ERROR: "Error",
    NOT_FOUND: "Not Found",
    TAGS: "Tags",
    RESOURCE_ONLY_TAGS: "Resource-Only Tags",
    ARCHIVED_CONTENT: "Archived Content",
    RESET_PASSWORD: "Reset Password",
    OPINION_EDITORIALS: "Opinion Editorials",
    OPINION_EDITORIALS_EDIT: "Edit Opinion Editorial",
    OPINION_EDITORIALS_CREATE: "Create Opinion Editorial",
    OPINION_EDITORIALS_SEARCH: "Opinion Editorials",
    QUOTES: "Transcripts",
    QUOTE_SEARCH: "Transcripts",
    SPEAKING_LIST: "Speaking List",
    TWEETS: "Tweet",
};


// WEBPACK FOOTER //
// ./src/pages/titles.ts